import appLogger from "../utils/app-logger";
import { apiService } from "../services/base-api-service";
import { endPoints, getABTestEndPoint } from "../services/api-constants";
import { getAuthHeader, readCookie } from "../utils/helpers";
import { getServiceToken } from "../utils/general-config";
//import header from "../components/header";

class ABTestService {
  ABTestService(url) {
    return getABTestEndPoint(url);
  }
  UserConduct(data) {
    appLogger.log("inside abtest user conduct ");
    if(readCookie("jwtToken")){
      const userConductEndpoint = this.ABTestService(`${endPoints.abtestService.USER_CONDUCT}`);
      return apiService.post(userConductEndpoint, data, getAuthHeader());
    }
  }
  VisitorConduct(data) {
    appLogger.log("inside abtest visitor conduct ");
    const visitorConductEndpoint = this.ABTestService(`${endPoints.abtestService.VISITOR_CONDUCT}`);
    const token = getServiceToken();
      if(token){
        const headers = {
          Authorization: `Bearer ${token}`,
        };
        return apiService.post(visitorConductEndpoint, data, headers);
    }
  }

  AbTestData(abTestId, userGuid) {
    appLogger.log("inside ab test data");
    const abTestDataCheckEndpoint = this.ABTestService(
      `${endPoints.abtestService.AB_TESTDATA.replace(":abTestId", abTestId).replace(":userGuid", userGuid)}`
    );
    return apiService.get(abTestDataCheckEndpoint, null, getAuthHeader());
  }

  SwitchVisitorUser(data) {
    if(readCookie("jwtToken")){
        const switchVisitorUserAbtestEndPoint = this.ABTestService(`${endPoints.abtestService.SWITCH_VISITOR_USER}`);
        return apiService.post(switchVisitorUserAbtestEndPoint, data, getAuthHeader());
    }
  }
}

export default new ABTestService();
